import React from 'react'
import { bool, string } from 'prop-types'
import { Button } from '@cobalt/cobalt-react-components'

const ActionButton = ({ isProcessing, children, isDisabled, ...props }) => (
  <Button
    {...props}
    state={isProcessing ? Button.LOADING_STATE : null}
    disabled={isDisabled || isProcessing}
  >
    {children}
  </Button>
)

ActionButton.propTypes = {
  isProcessing: bool,
  isDisabled: bool,
  children: string
}

export default ActionButton
